function mapPageSpecificMetaTags(page, cmsData) {
	const { htmlTitle, metaDescription } = cmsData?.pages?.[page]?.metadata || {};

	const output = {};
	if (metaDescription) output.description = metaDescription;
	if (htmlTitle) output.title = htmlTitle;
	return output;
}

export default function mapDoc(cmsData) {
	return {
		metaTags: {
			pageSpecificMetaTags: {
				boltGallery: mapPageSpecificMetaTags('gallery', cmsData),
				boltHome: mapPageSpecificMetaTags('home', cmsData),
				boltHomeEnt: mapPageSpecificMetaTags('homeEnt', cmsData),
				boltPreviewPanel: mapPageSpecificMetaTags('home', cmsData),
				boltShowtimes: mapPageSpecificMetaTags('showtimes', cmsData),
				boltSynopsis: mapPageSpecificMetaTags('synopsis', cmsData),
				boltVideos: mapPageSpecificMetaTags('videos', cmsData),
			},
		}
	};
}